import React from "react";
import { Check } from "lucide-react";
import { useSite } from "../contexts/SiteContext";

const AGE_IMG = {
  campus: "/images/campus.jpg",
  online: "/images/studying-online.jpg",
};

const Age = () => {
  const { content } = useSite();
  const a = content.age || {};
  return (
    <section style={{ padding: "90px 24px", background: "#E8E2F5" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56, alignItems: "center" }} className="age-grid">
        <div className="fade-in">
          <span className="pill" style={{ marginBottom: 16 }}>
            <span style={{ width: 18, height: 1, background: "#1A1352" }} /> {a.kicker}
          </span>
          <h2 className="h-display" style={{ fontSize: "clamp(32px, 4.4vw, 56px)", margin: "12px 0 18px" }}>
            {a.titleLine1}<br />
            {a.titleLine2Prefix}<span style={{ color: "#FF4F1A" }}>{a.titleLine2Highlight}</span>{a.titleLine2Suffix}
          </h2>
          <p style={{ color: "#5F5A72", fontSize: 16, lineHeight: 1.6, marginBottom: 20 }}>{a.subtitle}</p>
          <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 12 }}>
            {(a.bullets || []).map((t) => (
              <li key={t} style={{ display: "flex", alignItems: "flex-start", gap: 12, color: "#1A1352", fontSize: 15 }}>
                <span style={{ width: 24, height: 24, borderRadius: 8, background: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 2 }}>
                  <Check size={14} color="#5446EA" strokeWidth={3} />
                </span>
                {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="fade-in" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
          <div className="img-zoom-wrap card-soft" style={{ aspectRatio: "4/5", borderRadius: 24, gridRow: "span 2" }}>
            <img src={AGE_IMG.campus} alt="Campus" className="img-zoom" />
          </div>
          <div className="img-zoom-wrap card-soft" style={{ aspectRatio: "4/3", borderRadius: 24 }}>
            <img src={AGE_IMG.online} alt="Online" className="img-zoom" />
          </div>
          <div className="card-soft" style={{ background: "linear-gradient(160deg,#5446EA,#3F2DCB)", color: "#fff", borderRadius: 24, padding: 22, display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 160 }}>
            <span className="h-display" style={{ color: "#fff", fontSize: 44 }}>12+</span>
            <p style={{ fontSize: 12.5, opacity: 0.9, lineHeight: 1.4, margin: 0 }}>{a.chipText}</p>
          </div>
        </div>
      </div>
      <style>{`@media (max-width: 900px){.age-grid{grid-template-columns:1fr !important;gap:30px !important;}}`}</style>
    </section>
  );
};

export default Age;
